import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  width: 100%;
  top: 2.2rem;
  z-index: 10;
`;
